const shouldTrackEvents = () => {
	return window.DDC && window.DDC.isLive && window.DDC.pushToGtmDataLayer;
};

const dispatchTrackingEvent = (trackingEvent) => {
	const shouldTrack = shouldTrackEvents();

	// eslint-disable-next-line no-console
	if (console && console.log && !shouldTrack) {
		// eslint-disable-next-line no-console
		console.log(trackingEvent);
	}

	if (shouldTrack) {
		window.DDC.pushToGtmDataLayer(trackingEvent);
	}
};

const fireTrackableEvent = (eventData) => {
	dispatchTrackingEvent(eventData);
};

export default fireTrackableEvent;
